import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_54604f30 from 'nuxt_plugin_plugin_54604f30' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_nuxtmq_c54d6c64 from 'nuxt_plugin_nuxtmq_c54d6c64' // Source: ./nuxt-mq.js (mode: 'all')
import nuxt_plugin_image_aaba817e from 'nuxt_plugin_image_aaba817e' // Source: ./image.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_097f1e3f from 'nuxt_plugin_vuesocialsharingplugin_097f1e3f' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_dayjsplugin_a5d5c852 from 'nuxt_plugin_dayjsplugin_a5d5c852' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_index_d53eb7f0 from 'nuxt_plugin_index_d53eb7f0' // Source: ./firebase/index.js (mode: 'all')
import nuxt_plugin_serviceauthinitialize_3afb2bdd from 'nuxt_plugin_serviceauthinitialize_3afb2bdd' // Source: ./firebase/service.auth.initialize.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_674415ee from 'nuxt_plugin_cookieuniversalnuxt_674415ee' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_workbox_6cf6843c from 'nuxt_plugin_workbox_6cf6843c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_313b02f5 from 'nuxt_plugin_metaplugin_313b02f5' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_googlegtag_7b8a2475 from 'nuxt_plugin_googlegtag_7b8a2475' // Source: ./google-gtag.js (mode: 'client')
import nuxt_plugin_googleanalytics_0f318e20 from 'nuxt_plugin_googleanalytics_0f318e20' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_elementui_d905880e from 'nuxt_plugin_elementui_d905880e' // Source: ../plugins/element-ui (mode: 'client')
import nuxt_plugin_bootstrap_56cad686 from 'nuxt_plugin_bootstrap_56cad686' // Source: ../plugins/bootstrap.js (mode: 'client')
import nuxt_plugin_sweetalert2_37166c36 from 'nuxt_plugin_sweetalert2_37166c36' // Source: ../plugins/sweetalert2.js (mode: 'client')
import nuxt_plugin_vuecarousel_eb857b48 from 'nuxt_plugin_vuecarousel_eb857b48' // Source: ../plugins/vue-carousel.js (mode: 'client')
import nuxt_plugin_vuecropper_3413f3e5 from 'nuxt_plugin_vuecropper_3413f3e5' // Source: ../plugins/vue-cropper.js (mode: 'client')
import nuxt_plugin_vuecountdown_8a2485fe from 'nuxt_plugin_vuecountdown_8a2485fe' // Source: ../plugins/vue-countdown.js (mode: 'client')
import nuxt_plugin_vue2googlemaps_50810e79 from 'nuxt_plugin_vue2googlemaps_50810e79' // Source: ../plugins/vue2-google-maps.js (mode: 'client')
import nuxt_plugin_vueeasylightbox_8c753e1c from 'nuxt_plugin_vueeasylightbox_8c753e1c' // Source: ../plugins/vue-easy-lightbox.js (mode: 'client')
import nuxt_plugin_vueclipboard2_d47dc0c0 from 'nuxt_plugin_vueclipboard2_d47dc0c0' // Source: ../plugins/vue-clipboard2.js (mode: 'client')
import nuxt_plugin_vuescrollloader_063d875f from 'nuxt_plugin_vuescrollloader_063d875f' // Source: ../plugins/vue-scroll-loader.js (mode: 'client')
import nuxt_plugin_vuezoomonhover_74cf35ca from 'nuxt_plugin_vuezoomonhover_74cf35ca' // Source: ../plugins/vue-zoom-on-hover.js (mode: 'client')
import nuxt_plugin_vueyoutubeembed_b79b257a from 'nuxt_plugin_vueyoutubeembed_b79b257a' // Source: ../plugins/vue-youtube-embed.js (mode: 'client')
import nuxt_plugin_flicking_30123fa8 from 'nuxt_plugin_flicking_30123fa8' // Source: ../plugins/flicking.js (mode: 'client')
import nuxt_plugin_vuesocialsharing_1108e800 from 'nuxt_plugin_vuesocialsharing_1108e800' // Source: ../plugins/vue-social-sharing.js (mode: 'client')
import nuxt_plugin_vueportal_5951dd10 from 'nuxt_plugin_vueportal_5951dd10' // Source: ../plugins/vue-portal.js (mode: 'client')
import nuxt_plugin_vueslickcarousel_0c02c5e7 from 'nuxt_plugin_vueslickcarousel_0c02c5e7' // Source: ../plugins/vue-slick-carousel.js (mode: 'client')
import nuxt_plugin_vuelazycomponent_1e6bab98 from 'nuxt_plugin_vuelazycomponent_1e6bab98' // Source: ../plugins/vue-lazy-component.js (mode: 'client')
import nuxt_plugin_vueinfiniteloading_362f054e from 'nuxt_plugin_vueinfiniteloading_362f054e' // Source: ../plugins/vue-infinite-loading.js (mode: 'client')
import nuxt_plugin_vue2teleport_b89e1802 from 'nuxt_plugin_vue2teleport_b89e1802' // Source: ../plugins/vue2-teleport.js (mode: 'client')
import nuxt_plugin_pusher_73103fdc from 'nuxt_plugin_pusher_73103fdc' // Source: ../plugins/pusher.js (mode: 'client')
import nuxt_plugin_vuepdfviewer_6d5ae7e2 from 'nuxt_plugin_vuepdfviewer_6d5ae7e2' // Source: ../plugins/vue-pdf-viewer.js (mode: 'client')
import nuxt_plugin_vueclamp_00608bb7 from 'nuxt_plugin_vueclamp_00608bb7' // Source: ../plugins/vue-clamp.js (mode: 'client')
import nuxt_plugin_vuestarrating_3fe7f99a from 'nuxt_plugin_vuestarrating_3fe7f99a' // Source: ../plugins/vue-star-rating.js (mode: 'client')
import nuxt_plugin_cookiehelper_390cf154 from 'nuxt_plugin_cookiehelper_390cf154' // Source: ../plugins/cookie-helper.js (mode: 'all')
import nuxt_plugin_plugin_0b7d8302 from 'nuxt_plugin_plugin_0b7d8302' // Source: ./auth/plugin.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Paninti App","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Platform Belanja Kebutuhan Ibu & Anak"},{"hid":"og:title","name":"og:title","content":"Paninti App"},{"hid":"title","name":"title","content":"Paninti App"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"Paninti App"},{"hid":"apple-itunes-app","name":"apple-itunes-app","content":"app-id=1589005923, app-argument=https:\u002F\u002Fpaninti.com"},{"hid":"og:site_name","name":"og:site_name","content":"Paninti App"},{"hid":"og:description","name":"og:description","content":"Platform Belanja Kebutuhan Ibu & Anak"},{"hid":"og:image","name":"og:image","content":"https:\u002F\u002Fpaninti.com\u002Fdefault-og-image.png"},{"name":"theme-color","content":"#1659ab"},{"hid":"robots","name":"robots","content":"index"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"hid":"gf-prefetch","rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.gstatic.com\u002F"},{"hid":"gf-preconnect","rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com\u002F","crossorigin":""},{"hid":"gf-preload","rel":"preload","as":"style","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Open+Sans:wght@400;500;600;700;800&family=Lato:wght@400;700&family=Raleway:wght@400;500;600;700;800;900&display=swap"}],"noscript":[{"innerHTML":"This website requires JavaScript."},{"hid":"gf-noscript","innerHTML":"\u003Clink rel=\"stylesheet\" href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Open+Sans:wght@400;500;600;700;800&family=Lato:wght@400;700&family=Raleway:wght@400;500;600;700;800;900&display=swap\"\u003E"}],"__dangerouslyDisableSanitizers":["innerHTML"],"script":[{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-8G932KFQ30","async":true},{"hid":"gf-script","innerHTML":"(function(){var l=document.createElement('link');l.rel=\"stylesheet\";l.href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Open+Sans:wght@400;500;600;700;800&family=Lato:wght@400;700&family=Raleway:wght@400;500;600;700;800;900&display=swap\";document.querySelector(\"head\").appendChild(l);})();"}],"style":[],"__dangerouslyDisableSanitizersByTagID":{"gf-script":["innerHTML"],"gf-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_54604f30 === 'function') {
    await nuxt_plugin_plugin_54604f30(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtmq_c54d6c64 === 'function') {
    await nuxt_plugin_nuxtmq_c54d6c64(app.context, inject)
  }

  if (typeof nuxt_plugin_image_aaba817e === 'function') {
    await nuxt_plugin_image_aaba817e(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_097f1e3f === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_097f1e3f(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_a5d5c852 === 'function') {
    await nuxt_plugin_dayjsplugin_a5d5c852(app.context, inject)
  }

  if (typeof nuxt_plugin_index_d53eb7f0 === 'function') {
    await nuxt_plugin_index_d53eb7f0(app.context, inject)
  }

  if (typeof nuxt_plugin_serviceauthinitialize_3afb2bdd === 'function') {
    await nuxt_plugin_serviceauthinitialize_3afb2bdd(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_674415ee === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_674415ee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_6cf6843c === 'function') {
    await nuxt_plugin_workbox_6cf6843c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_313b02f5 === 'function') {
    await nuxt_plugin_metaplugin_313b02f5(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_80c87b74 === 'function') {
    await nuxt_plugin_axios_80c87b74(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlegtag_7b8a2475 === 'function') {
    await nuxt_plugin_googlegtag_7b8a2475(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_0f318e20 === 'function') {
    await nuxt_plugin_googleanalytics_0f318e20(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_elementui_d905880e === 'function') {
    await nuxt_plugin_elementui_d905880e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bootstrap_56cad686 === 'function') {
    await nuxt_plugin_bootstrap_56cad686(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sweetalert2_37166c36 === 'function') {
    await nuxt_plugin_sweetalert2_37166c36(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecarousel_eb857b48 === 'function') {
    await nuxt_plugin_vuecarousel_eb857b48(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecropper_3413f3e5 === 'function') {
    await nuxt_plugin_vuecropper_3413f3e5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecountdown_8a2485fe === 'function') {
    await nuxt_plugin_vuecountdown_8a2485fe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vue2googlemaps_50810e79 === 'function') {
    await nuxt_plugin_vue2googlemaps_50810e79(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueeasylightbox_8c753e1c === 'function') {
    await nuxt_plugin_vueeasylightbox_8c753e1c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueclipboard2_d47dc0c0 === 'function') {
    await nuxt_plugin_vueclipboard2_d47dc0c0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollloader_063d875f === 'function') {
    await nuxt_plugin_vuescrollloader_063d875f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuezoomonhover_74cf35ca === 'function') {
    await nuxt_plugin_vuezoomonhover_74cf35ca(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueyoutubeembed_b79b257a === 'function') {
    await nuxt_plugin_vueyoutubeembed_b79b257a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_flicking_30123fa8 === 'function') {
    await nuxt_plugin_flicking_30123fa8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuesocialsharing_1108e800 === 'function') {
    await nuxt_plugin_vuesocialsharing_1108e800(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueportal_5951dd10 === 'function') {
    await nuxt_plugin_vueportal_5951dd10(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueslickcarousel_0c02c5e7 === 'function') {
    await nuxt_plugin_vueslickcarousel_0c02c5e7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelazycomponent_1e6bab98 === 'function') {
    await nuxt_plugin_vuelazycomponent_1e6bab98(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueinfiniteloading_362f054e === 'function') {
    await nuxt_plugin_vueinfiniteloading_362f054e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vue2teleport_b89e1802 === 'function') {
    await nuxt_plugin_vue2teleport_b89e1802(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pusher_73103fdc === 'function') {
    await nuxt_plugin_pusher_73103fdc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuepdfviewer_6d5ae7e2 === 'function') {
    await nuxt_plugin_vuepdfviewer_6d5ae7e2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueclamp_00608bb7 === 'function') {
    await nuxt_plugin_vueclamp_00608bb7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuestarrating_3fe7f99a === 'function') {
    await nuxt_plugin_vuestarrating_3fe7f99a(app.context, inject)
  }

  if (typeof nuxt_plugin_cookiehelper_390cf154 === 'function') {
    await nuxt_plugin_cookiehelper_390cf154(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_0b7d8302 === 'function') {
    await nuxt_plugin_plugin_0b7d8302(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
